import { ref } from 'vue';

export function useRequestState() {
	const loading = ref(false);
	const completed = ref(false);

	function start() {
		loading.value = true;
	}

	function end() {
		if (loading.value) {
			loading.value = false;
		}
		if (!completed.value) {
			completed.value = true;
		}
	}

	return {
		loading,
		completed,
		start,
		end
	};
}
